export default __webpack_public_path__ + "static/media/banner-460x200-bg-pink-template.2008c30f.svg";